export const toGQLUrlParams = (query: string) => (query.startsWith('?') ? query.slice(1) : query);
